<template>
    <div class="form-container">
        <el-form v-loading="loading" ref="postForm" :validate-on-rule-change="false" v-if="postForm" :model="postForm" :rules="rules" class="form-container" :label-position="labelPosition" label-width="125px">
            <sticky :class-name="'sub-navbar draft'">
                <el-button v-loading="loading" size="small" @click="save(false)" type="success">SALVAR PARCIALMENTE / PREENCHER DEPOIS</el-button>
                <el-button v-loading="loading" size="small" @click="save(true)" style="margin-left: 10px;" type="success">FINALIZAR CADASTRO</el-button>
                <el-button v-loading="loading" size="small" @click="cancel()" type="danger">CANCELAR</el-button>
            </sticky>

            <h2>Cadastro Informações Pessoais</h2>

            <el-form-item prop="nome_completo" label="Nome Completo" class="postInfo-container-item">
                <el-input v-model="postForm.nome_completo"/>
            </el-form-item>

            <el-form-item prop="data_nascimento" label="Dt. Nascimento" class="postInfo-container-item">
                <el-date-picker v-model="postForm.data_nascimento" type="date" format="dd/MM/yyyy"/>
            </el-form-item>

            <el-form-item prop="sexo" label="Sexo" class="postInfo-container-item">
                <el-select v-model="postForm.sexo">
                    <el-option v-for="item in sexoOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
                </el-select>
            </el-form-item>

            <el-row :gutter="20">
                <el-col :xs="12" :sm="12">
                    <el-form-item prop="cpf" label="CPF" class="postInfo-container-item">
                        <el-input v-model="postForm.cpf" v-mask="'###.###.###-##'"/>
                    </el-form-item>
                </el-col>
                <el-col :xs="12" :sm="12">
                    <el-upload-x action="" accept="application/pdf" class="flex" :auto-upload="false" :limit="1" ref="anexo_cpf" :file-list="buildFileList(postForm.anexo_cpf)" prop="anexo_cpf" :on-remove="on_remove">
                        <el-tooltip class="item" effect="dark" content="Anexar CPF" placement="top-start">
                            <el-button type="primary">Importar</el-button>
                        </el-tooltip>
                    </el-upload-x>
                    <upload-error prop="anexo_cpf" :errors="invalidUploads"/>
                </el-col>
            </el-row>

            <el-row :gutter="20">
                <el-col :xs="12" :sm="12">
                    <el-form-item prop="rg" class="postInfo-container-item">
		        <template slot="label">RG <br><small style="position: relative; top: -25px;">(Frente e verso)</small></template>
                        <el-input v-model="postForm.rg"/>
                    </el-form-item>
                </el-col>
                <el-col :xs="6" :sm="6">
                    <el-form-item prop="orgao_emissor" label="" label-width="0px" class="postInfo-container-item">
                        <el-input v-model="postForm.orgao_emissor" placeholder="Orgão Emissor"/>
                    </el-form-item>
                </el-col>
                <el-col :xs="6" :sm="6">
                    <el-upload-x action="" accept="application/pdf" class="flex" :auto-upload="false" :multiple="false" :limit="1" ref="anexo_rg" :file-list="buildFileList(postForm.anexo_rg)" prop="anexo_rg" :on-remove="on_remove">
                        <el-tooltip class="item" effect="dark" content="Anexar RG" placement="top-start">
                            <el-button type="primary">Importar</el-button>
                        </el-tooltip>
                    </el-upload-x>
                    <upload-error prop="anexo_rg" :errors="invalidUploads"/>
                </el-col>
            </el-row>

            <el-row :gutter="20">
                <el-col :xs="18" :sm="18">
                    <el-form-item prop="rua" label="Rua" class="postInfo-container-item">
                        <el-input v-model="postForm.rua"/>
                    </el-form-item>
                </el-col>
                <el-col :xs="5" :sm="5">
                    <el-upload-x action="" accept="application/pdf" class="flex" :auto-upload="false" :multiple="false" :limit="1" ref="anexo_comprovante_residencia" :file-list="buildFileList(postForm.anexo_comprovante_residencia)" prop="anexo_comprovante_residencia" :on-remove="on_remove">
                        <el-tooltip class="item" effect="dark" content="Anexar imagem comprovante de residência" placement="top-start">
                            <el-button type="primary">Importar</el-button>
                        </el-tooltip>
                    </el-upload-x>
                    <upload-error prop="anexo_comprovante_residencia" :errors="invalidUploads"/>
                </el-col>
            </el-row>

            <el-row :gutter="20">
                <el-col :xs="12" :sm="12">
                    <el-form-item prop="numero" label="Número" class="postInfo-container-item">
                        <el-input v-model="postForm.numero"/>
                    </el-form-item>
                </el-col>
                <el-col :xs="12" :sm="12">
                    <el-form-item prop="complemento" label="Complemento"  class="postInfo-container-item">
                        <el-input v-model="postForm.complemento"/>
                    </el-form-item>
                </el-col>
            </el-row>

            <el-row :gutter="20">
                <el-col :xs="12" :sm="12">
                    <el-form-item prop="bairro" label="Bairro" class="postInfo-container-item">
                        <el-input v-model="postForm.bairro"/>
                    </el-form-item>
                </el-col>
                <el-col :xs="12" :sm="12">
                    <el-form-item prop="cep" label="CEP"  class="postInfo-container-item">
                        <el-input v-model="postForm.cep"/>
                    </el-form-item>
                </el-col>
            </el-row>

            <el-row :gutter="20">
                <el-col :xs="12" :sm="12">
                    <el-form-item prop="cidade" label="Cidade" class="postInfo-container-item">
                        <el-input v-model="postForm.cidade"/>
                    </el-form-item>
                </el-col>
                <el-col :xs="12" :sm="12">
                    <el-form-item prop="estado" label="Estado"  class="postInfo-container-item">
                        <el-select v-model="postForm.estado" filterable>
                            <el-option v-for="item in ufOptions" :key="item.key" :label="item.value" :value="item.key"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>

            <el-form-item prop="pais" label="País" class="postInfo-container-item">
                <el-input v-model="postForm.pais"/>
            </el-form-item>

            <el-form-item prop="telefone" label="Telefone" class="postInfo-container-item">
                <el-input v-model="postForm.telefone"/>
            </el-form-item>

            <el-row :gutter="20">
                <el-col :xs="12" :sm="12">
                    <el-form-item prop="estado_civil" label="Estado Civil" class="postInfo-container-item">
                        <el-select v-model="postForm.estado_civil">
                            <el-option v-for="item in estadoCivilOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :xs="6" :sm="6">
                    <el-upload-x action="" :disabled="postForm.estado_civil === 'Solteiro'" accept="application/pdf" class="flex" :auto-upload="false" :multiple="false" :limit="1" ref="anexo_certidao_estado_civil" :file-list="buildFileList(postForm.anexo_certidao_estado_civil)" prop="anexo_certidao_estado_civil" :on-remove="on_remove">
                        <el-tooltip class="item" effect="dark" content="Anexar certidão/declaração" placement="top-start">
                            <el-button type="primary" :disabled="postForm.estado_civil === 'Solteiro'">Importar</el-button>
                        </el-tooltip>
                    </el-upload-x>
                    <upload-error prop="anexo_certidao_estado_civil" :errors="invalidUploads"/>
                </el-col>
            </el-row>

            <el-row :gutter="20">
                <el-col :xs="9" :sm="6">
                    <el-form-item prop="ctps_numero" label="CTPS DIGITAL" class="postInfo-container-item">
                        <el-input v-model="postForm.ctps_numero" placeholder="Número"/>
                    </el-form-item>
                </el-col>
                <el-col :xs="4" :sm="3">
                    <el-form-item prop="ctps_serie" label="" label-width="0px" class="postInfo-container-item">
                        <el-input v-model="postForm.ctps_serie" placeholder="Série"/>
                    </el-form-item>
                </el-col>
                <el-col :xs="4" :sm="3">
                    <el-form-item prop="ctps_uf" label="" label-width="0px" class="postInfo-container-item">
                        <el-select v-model="postForm.ctps_uf" filterable placeholder="UF">
                            <el-option v-for="item in ufOptions" :key="item.key" :label="item.key" :value="item.key"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :xs="7" :sm="9">
                    <el-upload-x action="" accept="application/pdf" class="flex" :auto-upload="false" :multiple="false" :limit="1" ref="anexo_ctps" :file-list="buildFileList(postForm.anexo_ctps)" prop="anexo_ctps" :on-remove="on_remove">
                        <el-tooltip class="item" effect="dark" content="Anexar CTPS" placement="top-start">
                            <el-button type="primary">Importar</el-button>
                        </el-tooltip>
                    </el-upload-x>
                    <upload-error prop="anexo_ctps" :errors="invalidUploads"/>
                </el-col>
            </el-row>
            <el-row>
                <el-col :xs="24" style="height:25px;">
                    <label class="el-form-item__label" style="margin-left:125px; position:relative;top:-20px; padding: 0;">
                       <small>Anexar a CTPS Digital com o último contrato de trabalho. Nas lacunas acima, informar como número os (7 primeiros dígitos do CPF), a série (4 últimos dígitos do CPF), UF – RJ (localidade do empregador);</small>
                    </label>
                </el-col>
            </el-row>

            <el-row :gutter="20">
                <el-col :xs="12" :sm="12">
                    <el-form-item prop="pis" label="PIS" class="postInfo-container-item">
                        <el-input v-model="postForm.pis" v-mask="'###.#####.##-#'"/>
                    </el-form-item>
                </el-col>
                <el-col :xs="12" :sm="12">
                    <el-upload-x action="" accept="application/pdf" class="flex" :auto-upload="false" :multiple="false" :limit="1" ref="anexo_pis" :file-list="buildFileList(postForm.anexo_pis)" prop="anexo_pis" :on-remove="on_remove" >
                        <el-tooltip class="item" effect="dark" content="Anexar PIS" placement="top-start">
                            <el-button type="primary">Importar</el-button>
                        </el-tooltip>
                    </el-upload-x>
                    <upload-error prop="anexo_pis" :errors="invalidUploads"/>
                </el-col>
            </el-row>


            <el-form-item class="postInfo-container-item input-with-select" v-if="postForm.treinamentos && postForm.treinamentos.length > 0">
                <template slot="label"><div style="line-height: 18px;">Treinamento Especializado <small>(Exemplo NR`s, HUET, CBSP, etc.)</small></div></template>
                <el-row :gutter="20" v-for="(item, index) in postForm.treinamentos" :key="index" style="margin-bottom: 15px;overflow: hidden;">
                    <el-col :span="10">
                        <el-input :disabled="postForm.treinamentos_nao_se_aplica" v-model="item.descricao" placeholder="Descrição"/>
                        <div class="el-form-item__error el-form-item__error--inline" v-if="invalidTreinamentos && invalidTreinamentos['treinamentos.' + index + '.descricao']" style="margin-left: 0">
                            {{ invalidTreinamentos['treinamentos.' + index + '.descricao'][0]['message'] }}
                        </div>
                    </el-col>
                    <el-col :span="6">
                        <el-date-picker :disabled="postForm.treinamentos_nao_se_aplica" v-model="item.validade" placeholder="Validade" type="date" format="dd/MM/yyyy"/>
                        <div class="el-form-item__error el-form-item__error--inline" v-if="invalidTreinamentos && invalidTreinamentos['treinamentos.' + index + '.validade']" style="margin-left: 0">
                            {{ invalidTreinamentos['treinamentos.' + index + '.validade'][0]['message'] }}
                        </div>
                    </el-col>
                    <el-col :span="6">
                        <el-upload-x action="" :disabled="postForm.treinamentos_nao_se_aplica" accept="application/pdf" class="flex" :auto-upload="false" :multiple="false" :limit="1" :ref="'anexo_treinamento_' + index" :file-list="buildFileList(item.comprovante)" :prop="'anexo_treinamento_' + index" :on-remove="on_remove">
                            <el-tooltip class="item" effect="dark" content="Anexar Comprovante" placement="top-start">
                                <el-button :disabled="postForm.treinamentos_nao_se_aplica" type="primary">Importar</el-button>
                            </el-tooltip>
                        </el-upload-x>
                        <upload-error :prop="'anexo_treinamento_' + index" :errors="invalidUploads"/>
                    </el-col>
                </el-row>
                <el-button type="default" :disabled="postForm.treinamentos_nao_se_aplica" class="pull-right" @click="postForm.treinamentos.push({'descricao': null, 'validade': null})" size="mini">ADICIONAR <i class="el-icon-plus"></i></el-button> &nbsp;
                <el-switch v-model="postForm.treinamentos_nao_se_aplica" active-text="Não se aplica"> </el-switch>
            </el-form-item>

            <el-form-item prop="anexo_cnh" label-width="235px" class="postInfo-container-item">
                <template slot="label">CNH <small>(Carteira Nacional de Habilitação)</small></template>
                <el-upload-x action="" :disabled="postForm.cnh_nao_se_aplica" accept="application/pdf" class="flex" :auto-upload="false" :multiple="false" :limit="1" ref="anexo_cnh" :file-list="buildFileList(postForm.anexo_cnh)" prop="anexo_cnh" :on-remove="on_remove">
                    <el-tooltip class="item" effect="dark" content="Anexar CNH" placement="top-start">
                        <el-button type="primary" :disabled="postForm.cnh_nao_se_aplica" >Importar</el-button>
                    </el-tooltip>
                    <template slot="tip">
                        &nbsp; <el-switch v-model="postForm.cnh_nao_se_aplica" active-text="Não se aplica"> </el-switch>
                    </template>
                </el-upload-x>
                <upload-error prop="anexo_cnh" :errors="invalidUploads"/>
            </el-form-item>

            <el-form-item prop="anexo_certificado_reservista" label="Certificado de Reservista" label-width="235px" class="postInfo-container-item">
                <el-upload-x action="" :disabled="certificado_reservista_nao_se_aplica" accept="application/pdf" class="flex" :auto-upload="false" :multiple="false" :limit="1" ref="anexo_certificado_reservista" :file-list="certificado_reservista_nao_se_aplica ? [] : buildFileList(postForm.anexo_certificado_reservista)" prop="anexo_certificado_reservista" :on-remove="on_remove">
                    <el-tooltip class="item" effect="dark" content="Anexar Certificado" placement="top-start">
                        <el-button type="primary" :disabled="certificado_reservista_nao_se_aplica">Importar</el-button>
                    </el-tooltip>
                    <template slot="tip">
                        &nbsp; <el-switch :disabled="true" v-model="certificado_reservista_nao_se_aplica" active-text="Não se aplica"> </el-switch>
                    </template>
                </el-upload-x>
                <upload-error prop="anexo_certificado_reservista" :errors="invalidUploads"/>
            </el-form-item>

            <el-form-item prop="anexo_certidao_nascimento" label="Certidão de Nascimento" label-width="235px" class="postInfo-container-item is-required">
                <el-upload-x action="" accept="application/pdf" class="flex" :auto-upload="false" :multiple="false" :limit="1" ref="anexo_certidao_nascimento" :file-list="buildFileList(postForm.anexo_certidao_nascimento)" prop="anexo_certidao_nascimento" :on-remove="on_remove">
                    <el-tooltip class="item" effect="dark" content="Anexar Certidão" placement="top-start">
                        <el-button type="primary">Importar</el-button>
                    </el-tooltip>
                </el-upload-x>
                <upload-error prop="anexo_certidao_nascimento" :errors="invalidUploads"/>
            </el-form-item>

            <el-form-item label="Título de Eleitor" label-width="235px" prop="anexo_titulo_eleitor" class="postInfo-container-item is-required">
                <el-upload-x action="" accept="application/pdf" class="flex" :auto-upload="false" :multiple="false" :limit="1" ref="anexo_titulo_eleitor" :file-list="buildFileList(postForm.anexo_titulo_eleitor)" prop="anexo_titulo_eleitor" :on-remove="on_remove">
                    <el-tooltip class="item" effect="dark" content="Anexar Título" placement="top-start">
                        <el-button type="primary">Importar</el-button>
                    </el-tooltip>
                </el-upload-x>
                <upload-error prop="anexo_titulo_eleitor" :errors="invalidUploads"/>
            </el-form-item>

            <el-form-item prop="anexo_comprovante_contribuicao_sindical" label="Comprovante de Contribuicao Sindical" label-width="235px" class="postInfo-container-item multline-label">
                <el-upload-x action="" :disabled="postForm.comprovante_contribuicao_sindical_nao_se_aplica" accept="application/pdf" class="flex" :auto-upload="false" :multiple="false" :limit="1" ref="anexo_comprovante_contribuicao_sindical" :file-list="buildFileList(postForm.anexo_comprovante_contribuicao_sindical)" prop="anexo_comprovante_contribuicao_sindical" :on-remove="on_remove">
                    <el-tooltip class="item" effect="dark" content="Anexar Comprovante" placement="top-start">
                        <el-button type="primary" :disabled="postForm.comprovante_contribuicao_sindical_nao_se_aplica">Importar</el-button>
                    </el-tooltip>
                    <template slot="tip">
                        &nbsp; <el-switch v-model="postForm.comprovante_contribuicao_sindical_nao_se_aplica" active-text="Não se aplica"> </el-switch>
                    </template>
                </el-upload-x>
                <upload-error prop="anexo_comprovante_contribuicao_sindical" :errors="invalidUploads"/>
            </el-form-item>

            <el-form-item prop="anexo_comprovante_quitacao_eleitoral" label-width="235px" class="postInfo-container-item is-required multline-label">
                <template slot="label">Comprovante de Quitação Eleitoral - Clicar no link abaixo:<br><small><a target="_blank" href="http://www.tse.jus.br/eleitor/servicos/certidoes/certidao-de-quitacao-eleitoral">http://www.tse.jus.br/eleitor/servicos/certidoes/certidao-de-quitacao-eleitoral</a></small></template>
                <el-upload-x action="" accept="application/pdf" class="flex" :auto-upload="false" :multiple="false" :limit="1" ref="anexo_comprovante_quitacao_eleitoral" :file-list="buildFileList(postForm.anexo_comprovante_quitacao_eleitoral)" prop="anexo_comprovante_quitacao_eleitoral" :on-remove="on_remove">
                    <el-tooltip class="item" effect="dark" content="Anexar Comprovante" placement="top-start">
                        <el-button type="primary">Importar</el-button>
                    </el-tooltip>
                </el-upload-x>
                <upload-error prop="anexo_comprovante_quitacao_eleitoral" :errors="invalidUploads"/>
            </el-form-item>

            <el-form-item prop="anexo_comprovante_bancario" label-width="235px" class="postInfo-container-item is-required multline-label">
                <template slot="label">Cópia Comprovante Bancário <small>(Cartão frente e verso ou cheque com agência e conta legíveis)</small></template>
                <el-upload-x action="" accept="application/pdf" class="flex" :auto-upload="false" :multiple="false" :limit="1" ref="anexo_comprovante_bancario" :file-list="buildFileList(postForm.anexo_comprovante_bancario)" prop="anexo_comprovante_bancario" :on-remove="on_remove">
                    <el-tooltip class="item" effect="dark" content="Anexar Comprovante" placement="top-start">
                        <el-button type="primary">Importar</el-button>
                    </el-tooltip>
                </el-upload-x>
                <upload-error prop="anexo_comprovante_bancario" :errors="invalidUploads"/>
            </el-form-item>

            <el-form-item label="Foto 3x4" prop="anexo_foto3x4" label-width="235px" class="postInfo-container-item is-required">
                <el-upload action="" accept="application/pdf" class="flex" :auto-upload="false" :multiple="false" :limit="1" ref="anexo_foto3x4" :file-list="buildFileList(postForm.anexo_foto3x4)">
                    <el-tooltip class="item" effect="dark" content="Anexar Foto" placement="top-start">
                        <el-button type="primary">Importar</el-button>
                    </el-tooltip>
                </el-upload>
                <upload-error prop="anexo_foto3x4" :errors="invalidUploads"/>
            </el-form-item>

            <el-form-item prop="anexo_comprovante_escolar" label-width="235px" class="postInfo-container-item is-required">
                <template slot="label">Comprovante Escolar <br><small style="position: relative; top: -25px;">(Frente e verso)</small></template>
                <el-upload-x action="" accept="application/pdf" class="flex" :auto-upload="false" :multiple="false" :limit="1" ref="anexo_comprovante_escolar" :file-list="buildFileList(postForm.anexo_comprovante_escolar)" prop="anexo_comprovante_escolar" :on-remove="on_remove">
                    <el-tooltip class="item" effect="dark" content="Anexar Comprovante" placement="top-start">
                        <el-button type="primary">Importar</el-button>
                    </el-tooltip>
                </el-upload-x>
                <upload-error prop="anexo_comprovante_escolar" :errors="invalidUploads"/>
            </el-form-item>

            <el-form-item label="Comprovante Formação Técnica" prop="anexo_comprovante_formacao_tecnica" label-width="235px" class="postInfo-container-item">
                <el-upload-x :disabled="postForm.comprovante_formacao_tecnica_nao_se_aplica" action="" accept="application/pdf" class="flex" :auto-upload="false" :multiple="false" :limit="1" ref="anexo_comprovante_formacao_tecnica" :file-list="buildFileList(postForm.anexo_comprovante_formacao_tecnica)" prop="anexo_comprovante_formacao_tecnica" :on-remove="on_remove">
                    <el-tooltip class="item" effect="dark" content="Anexar Comprovante" placement="top-start">
                        <el-button :disabled="postForm.comprovante_formacao_tecnica_nao_se_aplica" type="primary">Importar</el-button>
                    </el-tooltip>
                    <template slot="tip">
                        &nbsp; <el-switch v-model="postForm.comprovante_formacao_tecnica_nao_se_aplica" active-text="Não se aplica"> </el-switch>
                    </template>
                </el-upload-x>
                <upload-error prop="anexo_comprovante_formacao_tecnica" :errors="invalidUploads"/>
            </el-form-item>

            <el-form-item prop="anexo_esocial" label-width="235px" class="postInfo-container-item multline-label">
                <template slot="label">Registro Profissional da Categoria<br></template>
                <el-upload-x :disabled="postForm.anexo_esocial" action="" accept="application/pdf" class="flex" :auto-upload="false" :multiple="false" :limit="1" ref="anexo_esocial" :file-list="buildFileList(postForm.anexo_esocial)" prop="anexo_esocial" :on-remove="on_remove">
                    <el-tooltip class="item" effect="dark" content="Anexar Declaração" placement="top-start">
                        <el-button type="primary" :disabled="postForm.anexo_esocial">Importar</el-button>
                    </el-tooltip>
                    <template slot="tip">
                        &nbsp; <el-switch v-model="postForm.anexo_esocial" active-text="Não se aplica"> </el-switch>
                    </template>
                </el-upload-x>
                <upload-error prop="anexo_esocial" :errors="invalidUploads"/>
            </el-form-item>

            <h4>Dependentes</h4>

            <div v-if="postForm.dependentes">

                <el-form-item  label="CPF Cônjuge" class="postInfo-container-item is-required" label-width="230px">
                    <el-upload-x action="" :disabled="postForm.dependentes.conjuge_cpf_nao_se_aplica"  accept="application/pdf" class="flex" :auto-upload="false" :multiple="false" :limit="1" ref="dependentes.conjuge_cpf" :file-list="buildFileList(postForm.dependentes.conjuge_cpf)" prop="dependentes.conjuge_cpf" :on-remove="on_remove">
                        <el-tooltip class="item" effect="dark" content="Anexar" placement="top-start">
                            <el-button type="primary" :disabled="postForm.dependentes.conjuge_cpf_nao_se_aplica">Importar</el-button>
                        </el-tooltip>
                        <template slot="tip">
                            &nbsp; <el-switch v-model="postForm.dependentes.conjuge_cpf_nao_se_aplica" active-text="Não se aplica"> </el-switch>
                        </template>
                    </el-upload-x>
                    <upload-error prop="dependentes.conjuge_cpf" :errors="invalidUploads"/>
                </el-form-item>

                <el-form-item class="postInfo-container-item is-required" label-width="230px">
                    <template slot="label">RG<br><small style="position: relative; top: -25px;">(Frente e verso)</small></template>
                    <el-upload-x action="" :disabled="postForm.dependentes.conjuge_rg_nao_se_aplica"  accept="application/pdf" class="flex" :auto-upload="false" :multiple="false" :limit="1" ref="dependentes.conjuge_rg" :file-list="buildFileList(postForm.dependentes.conjuge_rg)" prop="dependentes.conjuge_rg" :on-remove="on_remove">
                        <el-tooltip class="item" effect="dark" content="Anexar" placement="top-start">
                            <el-button type="primary" :disabled="postForm.dependentes.conjuge_rg_nao_se_aplica">Importar</el-button>
                        </el-tooltip>
                        <template slot="tip">
                             &nbsp; <el-switch v-model="postForm.dependentes.conjuge_rg_nao_se_aplica" active-text="Não se aplica"> </el-switch>
                        </template>
                    </el-upload-x>
                    <upload-error prop="dependentes.conjuge_cpf" :errors="invalidUploads"/>
                </el-form-item>

                <el-form-item label="Certidão Nascimento Filhos(as)" label-width="230px" class="postInfo-container-item input-with-select is-required multline-label">
                    <el-row :gutter="20" v-for="(item, index) in postForm.dependentes.filhos_certidao_nascimento" :key="index" style="margin-bottom: 15px;overflow: hidden;">
                        <el-col :span="6">
                            <el-upload-x action="" :disabled="postForm.dependentes.filhos_certidao_nascimento_nao_se_aplica" accept="application/pdf" class="flex" :auto-upload="false" :multiple="false" :limit="1" :ref="'dependentes.filhos_certidao_nascimento_' + index" :file-list="buildFileList(item)" :prop="'dependentes.filhos_certidao_nascimento_' + index" :on-remove="on_remove">
                                <el-tooltip class="item" effect="dark" content="Anexar" placement="top-start">
                                    <el-button :disabled="postForm.dependentes.filhos_certidao_nascimento_nao_se_aplica" type="primary">Importar</el-button>
                                </el-tooltip>
                            </el-upload-x>
                            <upload-error :prop="'dependentes.filhos_certidao_nascimento_' + index" :errors="invalidUploads"/>
                        </el-col>
                    </el-row>
                    <el-button type="default" :disabled="postForm.dependentes.filhos_certidao_nascimento_nao_se_aplica" class="pull-right" @click="postForm.dependentes.filhos_certidao_nascimento.push({})" size="mini">ADICIONAR <i class="el-icon-plus"></i></el-button> &nbsp;
                    <el-switch v-model="postForm.dependentes.filhos_certidao_nascimento_nao_se_aplica" active-text="Não se aplica"> </el-switch>
                </el-form-item>

                <el-form-item label-width="230px" class="postInfo-container-item input-with-select is-required multline-label">
                    <template slot="label">RG <br><small style="position: relative; top: -5px;">(Frente e verso)</small></template>
                    <el-row :gutter="20" v-for="(item, index) in postForm.dependentes.filhos_rg" :key="index" style="margin-bottom: 15px;overflow: hidden;">
                        <el-col :span="6">
                            <el-upload-x action="" :disabled="postForm.dependentes.filhos_rg_nao_se_aplica" accept="application/pdf" class="flex" :auto-upload="false" :multiple="false" :limit="1" :ref="'dependentes.filhos_rg_' + index" :file-list="buildFileList(item)" :prop="'dependentes.filhos_rg_' + index" :on-remove="on_remove">
                                <el-tooltip class="item" effect="dark" content="Anexar" placement="top-start">
                                    <el-button :disabled="postForm.dependentes.filhos_rg_nao_se_aplica" type="primary">Importar</el-button>
                                </el-tooltip>
                            </el-upload-x>
                            <upload-error :prop="'dependentes.filhos_rg_' + index" :errors="invalidUploads"/>
                        </el-col>
                    </el-row>
                    <el-button type="default" :disabled="postForm.dependentes.filhos_rg_nao_se_aplica" class="pull-right" @click="postForm.dependentes.filhos_rg.push({})" size="mini">ADICIONAR <i class="el-icon-plus"></i></el-button> &nbsp;
                    <el-switch v-model="postForm.dependentes.filhos_rg_nao_se_aplica" active-text="Não se aplica"> </el-switch>
                </el-form-item>

                <el-form-item label="CPF (filho(as))" label-width="230px" class="postInfo-container-item input-with-select is-required multline-label">
                    <el-row :gutter="20" v-for="(item, index) in postForm.dependentes.filhos_cpf" :key="index" style="margin-bottom: 15px;overflow: hidden;">
                        <el-col :span="6">
                            <el-upload-x action="" :disabled="postForm.dependentes.filhos_rg_nao_se_aplica" accept="application/pdf" class="flex" :auto-upload="false" :multiple="false" :limit="1" :ref="'dependentes.filhos_cpf_' + index" :file-list="buildFileList(item)" :prop="'dependentes.filhos_cpf_' + index" :on-remove="on_remove">
                                <el-tooltip class="item" effect="dark" content="Anexar" placement="top-start">
                                    <el-button :disabled="postForm.dependentes.filhos_cpf_nao_se_aplica" type="primary">Importar</el-button>
                                </el-tooltip>
                            </el-upload-x>
                            <upload-error :prop="'dependentes.filhos_cpf_' + index" :errors="invalidUploads"/>
                        </el-col>
                    </el-row>
                    <el-button type="default" :disabled="postForm.dependentes.filhos_cpf_nao_se_aplica" class="pull-right" @click="postForm.dependentes.filhos_cpf.push({})" size="mini">ADICIONAR <i class="el-icon-plus"></i></el-button> &nbsp;
                    <el-switch v-model="postForm.dependentes.filhos_cpf_nao_se_aplica" active-text="Não se aplica"> </el-switch>
                </el-form-item>

                <el-form-item label-width="230px" class="postInfo-container-item input-with-select is-required multline-label">
                    <template slot="label">Comprovante escolar <br><small style="position: relative; top: -5px;">(Frente e verso)</small></template>
                    <el-row :gutter="20" v-for="(item, index) in postForm.dependentes.filhos_comprovante_escolar" :key="index" style="margin-bottom: 15px;overflow: hidden;">
                        <el-col :span="6">
                            <el-upload-x action="" :disabled="postForm.dependentes.filhos_comprovante_escolar_nao_se_aplica" accept="application/pdf" class="flex" :auto-upload="false" :multiple="false" :limit="1" :ref="'dependentes.filhos_comprovante_escolar_' + index" :file-list="buildFileList(item)" :prop="'dependentes.filhos_comprovante_escolar_' + index" :on-remove="on_remove">
                                <el-tooltip class="item" effect="dark" content="Anexar" placement="top-start">
                                    <el-button :disabled="postForm.dependentes.filhos_comprovante_escolar_nao_se_aplica" type="primary">Importar</el-button>
                                </el-tooltip>
                            </el-upload-x>
                            <upload-error :prop="'dependentes.filhos_comprovante_escolar_' + index" :errors="invalidUploads"/>
                        </el-col>
                    </el-row>
                    <el-button type="default" :disabled="postForm.dependentes.filhos_comprovante_escolar_nao_se_aplica" class="pull-right" @click="postForm.dependentes.filhos_comprovante_escolar.push({})" size="mini">ADICIONAR <i class="el-icon-plus"></i></el-button> &nbsp;
                    <el-switch v-model="postForm.dependentes.filhos_comprovante_escolar_nao_se_aplica" active-text="Não se aplica"> </el-switch>
                </el-form-item>

            </div>

            <h4>Formulários para preenchimento e assinatura</h4>
            <el-button-group>
                <a class="el-button el-button--default" v-if="postForm.beneficio" target="_blank" href="/modelos/Brunel_Energy_Formulario_Beneficios_Com_Vale_Combustivel.pdf">Benefícios</a>
                <a class="el-button el-button--default" v-else target="_blank" href="/modelos/formulario_beneficios.pdf">Benefícios</a>
                <a class="el-button el-button--default" target="_blank" href="/modelos/formulario_IRRF.pdf">IR</a>
                <a class="el-button el-button--default" target="_blank" href="/modelos/Formulario Seguro de Vida SulAmerica.pdf">Seguro Vida</a>
                <a class="el-button el-button--default" target="_blank" href="/modelos/formulario_dados_pessoais_v5.pdf">Dados Pessoais</a>
            </el-button-group>

            <h4>Formulários para baixar e anexar assinados e digitalizados (somente pdf)</h4>
            <el-form-item label="Beneficios" prop="anexo_formulario_beneficios" label-width="230px" class="postInfo-container-item is-required">
                    <el-upload-x action="" accept="application/pdf" :auto-upload="false" class="flex" :multiple="false" :limit="1" ref="anexo_formulario_beneficios" :file-list="buildFileList(postForm.anexo_formulario_beneficios)" prop="anexo_formulario_beneficios" :on-remove="on_remove">
                        <el-tooltip class="item" effect="dark" content="Anexar Documento" placement="top-start">
                            <el-button type="primary">Importar</el-button>
                        </el-tooltip>
                    </el-upload-x>
                    <upload-error prop="anexo_formulario_beneficios" :errors="invalidUploads"/>
            </el-form-item>

            <el-form-item label="IR" prop="anexo_formulario_ir" label-width="230px" class="postInfo-container-item is-required">
                <el-upload-x action="" accept="application/pdf" :auto-upload="false" class="flex" :multiple="false" :limit="1" ref="anexo_formulario_ir" :file-list="buildFileList(postForm.anexo_formulario_ir)" prop="anexo_formulario_ir" :on-remove="on_remove">
                    <el-tooltip class="item" effect="dark" content="Anexar Documento" placement="top-start">
                        <el-button type="primary">Importar</el-button>
                    </el-tooltip>
                </el-upload-x>
                <upload-error prop="anexo_formulario_ir" :errors="invalidUploads"/>
            </el-form-item>

            <el-form-item label="Seguro Vida" prop="anexo_formulario_seguro_vida" label-width="230px" class="postInfo-container-item is-required">
                <el-upload-x action="" accept="application/pdf" :auto-upload="false" class="flex" :multiple="false" :limit="1" ref="anexo_formulario_seguro_vida" :file-list="buildFileList(postForm.anexo_formulario_seguro_vida)" prop="anexo_formulario_seguro_vida" :on-remove="on_remove">
                    <el-tooltip class="item" effect="dark" content="Anexar Documento" placement="top-start">
                        <el-button type="primary">Importar</el-button>
                    </el-tooltip>
                </el-upload-x>
                <upload-error prop="anexo_formulario_seguro_vida" :errors="invalidUploads"/>
            </el-form-item>

            <el-form-item label="Dados Pessoais" prop="anexo_formulario_beneficios"  label-width="230px" class="postInfo-container-item is-required">
                <el-upload-x action="" accept="application/pdf" :auto-upload="false" class="flex" :multiple="false" :limit="1" ref="anexo_formulario_dados_pessoais" :file-list="buildFileList(postForm.anexo_formulario_dados_pessoais)" prop="anexo_formulario_dados_pessoais" :on-remove="on_remove">
                    <el-tooltip class="item" effect="dark" content="Anexar Documento" placement="top-start">
                        <el-button type="primary">Importar</el-button>
                    </el-tooltip>
                </el-upload-x>
                <upload-error prop="anexo_formulario_beneficios" :errors="invalidUploads"/>
            </el-form-item>

            <hr style="margin-top: 60px;border-bottom: 1px solid #ccc;border-top: none;">
            <div class="el-form-item postInfo-container-item input-with-select is-required">
                <label class="el-form-item__label">Preenchimento obrigatório</label>
            </div>
        </el-form>
    </div>
</template>


<script>
import request from '@/request'
import Sticky from '@/components/Sticky'
import ElUploadX from '@/components/Upload/src'
import UploadError from '@/components/UploadError'
import AsyncValidator from 'async-validator'
import moment from 'moment'
import { mask } from 'vue-the-mask'
import { validateCPF } from '@/validadores'

export default {
    name: 'AdmissaoForm',
    components: { Sticky, UploadError, ElUploadX },
    directives: { mask },
    data() {
        return {
            loading: false,
            postForm: {},
            labelPosition: 'left',
            sexoOptions: [
                { value: 'M', label: 'Masculino' },
                { value: 'F', label: 'Feminino' }
            ],
            estadoCivilOptions: [
                { value: 'Solteiro', label: 'Solteiro(a)' },
                { value: 'Casado', label: 'Casado(a)' },
                { value: 'Divorciado', label: 'Divorciado(a)' }
            ],
            ufOptions: [
                { key: "AC", value: "Acre" },
                { key: "AL", value: "Alagoas" },
                { key: "AP", value: "Amapá" },
                { key: "AM", value: "Amazonas" },
                { key: "BA", value: "Bahia" },
                { key: "CE", value: "Ceará" },
                { key: "DF", value: "Distrito Federal" },
                { key: "ES", value: "Espírito Santo" },
                { key: "GO", value: "Goiás" },
                { key: "MA", value: "Maranhão" },
                { key: "MT", value: "Mato Grosso" },
                { key: "MS", value: "Mato Grosso do Sul" },
                { key: "MG", value: "Minas Gerais" },
                { key: "PA", value: "Pará" },
                { key: "PB", value: "Paraíba" },
                { key: "PR", value: "Paraná" },
                { key: "PE", value: "Pernambuco" },
                { key: "PI", value: "Piauí" },
                { key: "RJ", value: "Rio de Janeiro" },
                { key: "RN", value: "Rio Grande do Norte" },
                { key: "RS", value: "Rio Grande do Sul" },
                { key: "RO", value: "Rondônia" },
                { key: "RR", value: "Roraima" },
                { key: "SC", value: "Santa Catarina" },
                { key: "SP", value: "São Paulo" },
                { key: "SE", value: "Sergipe" },
                { key: "TO", value: "Tocantins" }
            ],
            invalidUploads: [],
            invalidTreinamentos: []
        }
    },
    created() {
        this.fetchData();
    },
    computed: {
        certificado_reservista_nao_se_aplica() {
            return this.postForm.sexo == 'F'
        },
        rules_treinamentos: function() {
            const treinamentos = {}
            for (const x of Array(10).keys()) {
                treinamentos[x] = {
                    type: "object",
                    fields: {
                        validade: { type: "date", required: true, message: "Preenchimento Obrigatório"},
                        descricao: {type: "string",  message: "Preenchimento Obrigatório", required: true},
                    }
                }
            }

            return {
                treinamentos: {
                    type: "array", required: true,
                    fields: treinamentos
                }
            }
        },
        rules: function() {

            const messages = {
                required: 'Preenchimento Obrigatório',
                email: 'Endereço de email inválido',
                date: 'Data inválida',
                invalid: 'Opção inválida'
            }

            const validatorCPF = (rule, value, callback) => {
                if (!validateCPF(value)) {
                    callback(new Error(rule.message))
                } else {
                    callback()
                }
            }

            const rules = {
                nome_completo: [{ required: true, messages: messages.required, trigger: 'blur' }],
                cpf: [{required: true, message: messages.required, trigger: 'blur' },
                    {validator: validatorCPF, message: 'CPF inválido'}],
                rg: [{ required: true, message: messages.required, trigger: 'blur' }],
                orgao_emissor: [{ required: true, message: messages.required, trigger: 'blur' }],
                data_nascimento: [{ required: true, message: messages.required, trigger: 'blur' }],
                telefone: [{ required: true, message: messages.required, trigger: 'blur' }],
                sexo: [
                    { required: true, message: messages.required, trigger: 'change' },
                    { type: 'enum', enum: ['M', 'F'], message: messages.invalid, trigger: 'change' }
                ],
                rua: [{ required: true, message: messages.required, trigger: 'blur' }],
                numero: [{ required: true, message: messages.required, trigger: 'blur' }],
                bairro: [{ required: true, message: messages.required, trigger: 'blur' }],
                cep: [{ required: true, message: messages.required, trigger: 'blur' }],
                cidade: [{ required: true, message: messages.required, trigger: 'blur' }],
                estado: [{ required: true, message: messages.required, trigger: 'blur' }],
                pais: [{ required: true, message: messages.required, trigger: 'blur' }],
                ctps_numero: [{ required: true, message: messages.required, trigger: 'blur' }],
                ctps_serie: [{ required: true, message: messages.required, trigger: 'blur' }],
                ctps_uf: [{ required: true, message: messages.required, trigger: 'blur' }],
                pis: [{ required: true, message: messages.required, trigger: 'blur' }],
                estado_civil: [{ required: true, message: messages.required, trigger: 'blur' }],

                anexo_cpf: [{ required: true, message: messages.required, trigger: 'blur' }]
            }

            return rules
        }
    },
    methods: {
        fetchData() {
            this.loading = true
        request({
            url: `funcionario/${this.$route.params.uid}`,
            method: 'get',
        }).then(response => {
            this.loading = false
            this.postForm = response.data

            this.postForm.data_nascimento = moment(String(this.postForm.data_nascimento)).toDate()

            if (this.postForm.dependentes == null) {
                this.postForm.dependentes = {
                    filhos_certidao_nascimento: [{}],
                    filhos_rg: [{}],
                    filhos_cpf: [{}],
                    filhos_comprovante_escolar: [{}],
                }
            }

            if (this.postForm.treinamentos.length > 0) {
                this.postForm.treinamentos.forEach(el => {
                    el.validade = moment(String(el.validade)).toDate()
                })
            }

        }, error => {
            this.loading = false
            if ( error.response.status === 404) {
                this.$router.push('/invalido')
            } else {
                this.$message({
                    showClose: true,
                    message: `Falha ao recuperar dados do formulário ${error.bodyText}`,
                    type: 'error'
                })
            }
        })
    },
    save(finish) {
        this.loading = true
        const formData = this.prepareData(finish)

        if (finish) {
            this.$refs['postForm'].validate(valid => {
                if (valid && this.invalidUploads.length == 0 && ( !this.invalidTreinamentos || this.invalidTreinamentos.length == 0)) {
                    this.submitData(formData, finish)
                } else {
                    this.loading = false
                }
            })
        } else {
            this.submitData(formData, finish)
        }
    },
    submitData(data, finish) {
        const action = finish ? 'finalizar' : 'gravar'
        request({
            url: `funcionario/${this.$route.params.uid}/${action}`,
            method: 'PUT',
            data: data,
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }).then(() => {
            this.loading = false
            if ( finish ) {
                this.$router.push('/finalizado')
            } else {
                this.$message({
                    showClose: true,
                    message: `Formulário atualizado com sucesso`,
                    type: 'success'
                })
            }
          }, error => {
            this.loading = false

            try {
                this.$message({
                    showClose: true,
                    message: `Falha ao salvar formulário: ${error.response.data.description}`,
                    type: 'error'
                })

                if (error.response.data.fields) {
                    error.response.data.fields.forEach(postFile => {
                        this.invalidUploads.push({key: postFile.key, message: 'Formato ' + postFile.mimetype + ' inválido'})
                    })

                }
            } catch(e) {
                this.$message({
                    showClose: true,
                    message: `Falha ao salvar formulário: Network error`,
                    type: 'error'
                })
            }
        })
    },
    prepareData(finish) {
        this.invalidTreinamentos = []
        this.invalidUploads = []
        const formData = new FormData()
        const postData = Object.assign({}, this.postForm)
        const anexos = Object.keys(this.$refs).filter(item => {
            return item.startsWith('anexo') || item.startsWith('dependentes')
        })

        if ( !this.treinamentos_disabled && finish ) {
            const validator = new AsyncValidator(this.rules_treinamentos);
            validator.validate({ treinamentos: this.postForm.treinamentos }, (errors, fields) => {
                this.invalidTreinamentos = fields
            });
        }

        formData.append('admissao', JSON.stringify(postData))

        anexos.forEach(postFile => {
            let upload = this.$refs[postFile];
            if (Array.isArray(this.$refs[postFile])) {
                upload = this.$refs[postFile][0]
            }
            //upload.disabled
            if (upload.uploadFiles[0]) {
                if (upload.uploadFiles[0].raw) {
                    formData.append(postFile, upload.uploadFiles[0].raw)
                }
            } else {
                if (finish && !upload.disabled) {
                    this.invalidUploads.push({key: postFile, message: 'Upload obrigatório'})
                }
            }
        }, this)

        return formData
    },
    cancel() {
        this.$router.push('/cancelar')
    },
    buildFileList(anexo) {
        if (anexo && Object.keys(anexo).length > 0) {
            const files =  [{name: anexo.nome, url: anexo.url}]
            return files
        }
    },
    on_remove(file, filelist, prop) {
        if (prop.startsWith('dependentes.')) {

            if ( prop.startsWith('dependentes.filhos_cpf_') ) {
                const idx = prop.replace('dependentes.filhos_cpf_', '')
                this.postForm['dependentes']['filhos_cpf'][idx] = {}
            } else if ( prop.startsWith('dependentes.filhos_comprovante_escolar_') ) {
                const idx = prop.replace('dependentes.filhos_comprovante_escolar_', '')
                this.postForm['dependentes']['filhos_comprovante_escolar'][idx] = {}
            } else if ( prop.startsWith('dependentes.filhos_rg_') ) {
                const idx = prop.replace('dependentes.filhos_rg_', '')
                this.postForm['dependentes']['filhos_rg'][idx] = {}
            } else if ( prop.startsWith('dependentes.filhos_certidao_nascimento_') ) {
                const idx = prop.replace('dependentes.filhos_certidao_nascimento_', '')
                this.postForm['dependentes']['filhos_certidao_nascimento'][idx] = {}
            } else {
                this.postForm['dependentes'][prop.replace('dependentes.', '')] = null
            }

        } else {
            this.postForm[prop] = null
        }

    }
  }
}
</script>

<style>
.flex {
    display: flex;
    flex-wrap: nowrap;
    align-items: center;
}

.input-with-select .el-date-editor.el-input, .el-date-editor.el-input__inner, .el-select{
    width: 100%;
}

.multline-label label {
    line-height: 18px;
}

.sub-navbar {
  height: 50px;
  line-height: 50px;
  position: relative;
  width: 100%;
  text-align: right;
  padding-right: 20px;
  transition: 600ms ease position;
  background: #F2F6FC;
}

a.el-button {
    text-decoration: none;
}
</style>
